module.exports = __webpack_public_path__ + "img/rbs.d1959a8a.svg";